import classNames from "classnames";
import compact from "lodash/compact";
import { Inline } from "PFComponents/containers";
import { LabelIcon, LabelIconConfig } from "PFComponents/label/label_icon";
import { Typography, TypographyProps } from "PFComponents/typography";
import { VariantBody, VariantLabel } from "PFComponents/typography/typography.types";
import { useTranslation } from "react-i18next";

import css from "./label.module.scss";

export type LabelIcons = LabelIconConfig[];

type LabelProps = Pick<TypographyProps, "withMargin" | "id"> & {
  text?: string | null;
  icons?: LabelIcons;
  required?: boolean;
  variant?: VariantLabel | VariantBody;
  inputId?: string;
  disabled?: boolean;
  className?: string;
  qaId?: string;
};

export const Label = ({
  text,
  icons = [],
  required,
  variant = "labelRegular",
  inputId,
  disabled,
  qaId,
  className,
  withMargin,
  id
}: LabelProps) => {
  const { t } = useTranslation("core");

  const mandatoryIcon =
    required &&
    ({
      icon: "mandatory",
      text: t("components.requiredText.mandatory")
    } as LabelIconConfig);

  if (!text) {
    return null;
  }

  return (
    <Inline<"label">
      id={id}
      alignItems="center"
      gap="spacingSm"
      as={inputId ? "label" : "span"}
      htmlFor={inputId}
      className={classNames(css.label, disabled && css.disabled, className)}
      title={text}
      data-qa-id={qaId}
    >
      <Typography tag="span" variant={variant} clipOverflow title={text} withMargin={withMargin}>
        {text}
      </Typography>
      {compact([...icons, mandatoryIcon]).map((iconConfig) => (
        <LabelIcon key={iconConfig.icon} {...iconConfig} disabled={disabled} />
      ))}
    </Inline>
  );
};
